import { useTranslation } from 'zf-web-components';
import { useNavigate, useSearchParams } from 'react-router';
import { useContext, useEffect, useState } from 'react';
import { RootContext } from '../stores';
import type { Newable } from 'zf-web-infra';
import type { ContentResult, UseContentOptions, UseContentResult } from './types';

export function useContent<T extends Newable>(Store: T, initialParams?: UseContentOptions): UseContentResult<T> {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // 提取 url 参数，将 URLSearchParams 转换为对象
  const params: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  // 生成 store 实例
  const root = useContext(RootContext);
  const [t] = useTranslation();
  const [store] = useState(() => new Store({ root, navigate, params, initialParams }));

  function beforeUnloadCallback(event: BeforeUnloadEvent): void {
    const isPrevent = store.onUnLoad();
    if (isPrevent === true) {
      event.preventDefault();
      event.returnValue = ''; // 兼容旧浏览器
    }
  }

  // 调用 store 的 onLoad 方法，并注册 onUnLoad 方法的调用
  function useOnload(): ContentResult<T> {
    useEffect(() => {
      store.onLoad?.();
      if (store.onUnLoad != null) {
        window.addEventListener('beforeunload', beforeUnloadCallback, true);
      }
      return (): void => {
        window.removeEventListener('beforeunload', beforeUnloadCallback, true);
      };
    }, []);
    return { store, t, root };
  }

  return useOnload;
}
